import React from 'react';
import {
    connect,
} from 'react-redux';

// Components
import ConnectedLeasesModule from 'app/shared/components/ConnectedLeasesModule';
import ConnectedPaymentsModule from 'app/shared/components/ConnectedPaymentsModule';

// auth
import AuthCheckWrapper from 'app/shared/containers/AuthCheckWrapper';
import PermissionCheck from 'app/shared/components/PermissionCheck';

import { MANAGE_TENANTS_PATH } from 'app/shared/constants/RouteConstants';

import {
    Row,
} from '@zillow/zrs-comet';

// Styles
import {
    StyledCol,
} from './StyledComponents';

const ManageTenantsPage = (props) => {
    const { location } = props;

    return (
        <AuthCheckWrapper requireStrongAuthentication={false}>
            <PermissionCheck route={MANAGE_TENANTS_PATH}>
                <Row
                    paddingX={0}
                    paddingY={0}
                >
                    <StyledCol
                        className="ConnectedLeases-Col-Temp"
                        paddingY={0}
                        xs={12}
                        lg={4}
                    >
                        <ConnectedLeasesModule location={location} />
                    </StyledCol>

                    <StyledCol
                        className="ConnectedPayments-Col-Temp"
                        paddingY={0}
                        xs={12}
                        lg={8}
                    >

                        <ConnectedPaymentsModule location={location} />
                    </StyledCol>
                </Row>
            </PermissionCheck>
        </AuthCheckWrapper>
    );
};

ManageTenantsPage.propTypes = {};
ManageTenantsPage.defaultProps = {};

const mapStateToProps = (state, ownProps) => ({
    propertyId: ownProps.match.params.propertyId,
});

export default connect(mapStateToProps)(ManageTenantsPage);
